<template>
  <div ref="carousel">
    <slot />
  </div>
</template>

<script>
import $ from 'jquery'
import slick from 'slick-carousel'

export default {
  mounted() {
    $(this.$refs.carousel).slick({
      arrows: false,
      slidesToShow: 3,
      mobileFirst: true,
      swipeToSlide: true,

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            infinite: false,
            draggable: false,
          },
        },
      ],
    })
  },
}
</script>

<style lang="scss">
@import 'slick-carousel/slick/slick.scss';
</style>
